export function useLang() {
	const config = useAppConfig();
	const {getUrlSegments} = useUrl();
	const lang = useState('lang', () => (config.lang ? config.lang : 'hr'));

	const langs = {
		hr: {code: 'hr', lang: 'hr', base_url: '/hr/', locale: 'hr-HR', currency: '€', currency_code: 'EUR'},
		en: {code: 'en', lang: 'en', base_url: '/en/', locale: 'en-GB', currency: '€', currency_code: 'EUR'},
		de: {code: 'de', lang: 'de', base_url: '/de/', locale: 'de-DE', currency: '€', currency_code: 'EUR'},
		at: {code: 'at', lang: 'de', base_url: '/de/', locale: 'de-AT', currency: '€', currency_code: 'EUR'},
		rs: {code: 'rs', lang: 'sr', base_url: '/rs/', locale: 'sr-RS', currency: 'RSD', currency_code: 'RSD'},
		si: {code: 'si', lang: 'sl', base_url: '/si/', locale: 'sl-SI', currency: '€', currency_code: 'EUR'},
		it: {code: 'it', lang: 'it', base_url: '/it/', locale: 'it-IT', currency: '€', currency_code: 'EUR'},
		ba: {code: 'ba', lang: 'bs', base_url: '/ba/', locale: 'bs-BA', currency: 'BAM', currency_code: 'BAM'},
		me: {code: 'me', lang: 'sr', base_url: '/me/', locale: 'sr-ME', currency: '€', currency_code: 'EUR'},
		es: {code: 'es', lang: 'es', base_url: '/es/', locale: 'es-ES', currency: '€', currency_code: 'EUR'},
	};

	// get all data for specific language. If no payload, return current language data
	function getLang(payload) {
		return payload ? langs[payload] : langs[lang.value];
	}

	// get specified data for current language. If no payload, return current language code
	function get(payload) {
		return payload ? langs[lang.value][payload] : langs[lang.value].code;
	}

	// set current language
	function set(payload) {
		if (!payload) {
			useLog('useLang.set: Language is not provided.', 'error');
		}
		lang.value = payload;
	}

	function getLangFromUrl(url) {
		const urlSegments = getUrlSegments(url);
		if (urlSegments?.length && langs[urlSegments[0]]) {
			return urlSegments[0];
		}

		return lang.value;
	}

	function isDefaultLang() {
		return lang.value == config.lang || config.multiHost?.length ? true : false;
	}

	return {langs, get, set, getLang, getLangFromUrl, isDefaultLang};
}
